function pushDatalayer(payload) {
    if (window.dataLayer) {
        console.log('dataLayer.push:', payload);
        window.dataLayer.push(payload);
    }
}

export { pushDatalayer };
